// removed by extract-text-webpack-plugin
module.exports = {"taskFailed":"_2fFN-HewDw7t6Hqg7jDKgn","taskNeutral":"_2hUkgQLgbxLmCU7DjiEnMX","taskSucceeded":"_1aFlLC0krKEa_9fpr8iH0n","spinner":"UNJx5S6bcmgYUiIJ6MGo8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SaveMergedDeck/SaveMergedDeck.css
// module id = 372
// module chunks = 0